/**
 * General
 */
const CONTAINER_WRAPPER = 1680;
const SPACING_WIDTH_DESKTOP = 70;
const DROPDOWN_ACTIVE_CLASS = "dropdown-active";
const AUTO = "auto";
const MASK_ACTIVE_CLASS = "mask-active";
const PAGE_HEIGHT_SET_TIMING = 200;
const PERCENTAGE_SYMBOL = "%";
const MIN_PRODUCT_QUANTITY = 1;

/**
 * BRANDS ID constants
 */
const BRAND_COL = "col";
const BRAND_ZU = "zu";

/**
 * BRANDS NAME constants
 */
const BRAND_NAME_COL = "CONTINENTE";
const BRAND_NAME_ZU = "ZU";


/**
 * CLP constants
 */
const CATEGORY_REFINEMENT_LIMIT = 5;


/**
 * Map constants
 */
const MAP_MARKER_PATH = "M5.432 0C2.437 0 0 2.437 0 5.432c0 3.718 4.862 9.175 5.068 9.406.195.216.534.216.728 0 .207-.23 5.069-5.688 5.069-9.406C10.865 2.437 8.428 0 5.432 0z";
const MAP_MARKER_COLOR = "#EB0203";
const MAP_DARK_MARKER_COLOR = "#7F1215";
const MAP_LABEL_COLOR = "#FFF";
const MAP_LABEL_FONT_SIZE = "13px";
const MAP_AUTH_FAILED_CLASS = "js-gm-auth-failed";

/**
 * Delivery Schedule constants
 */
const SCHEDULE_ITEM_HEIGHT = 56;
const SCHEDULE_COLUMNS_NUMBER = 3;
const SCHEDULE_COLUMNS_NUMBER_TABLET = 2;

/**
 * Payment constants
 */
const PAYMENT_METHOD_INPUT_DEFAULT_NAME = "dwfrm_billing_paymentMethod";
const PAYMENT_METHOD_MODE_OFFLINE = "OFFLINE";
const PAYMENT_METHOD_GIFT_CARD = "GiftCard";
const PAYMENT_METHOD_LOYALTY_CARD = "LoyaltyCard";
const PAYMENT_METHOD_CREDIT_CARD = "CreditCard";
const PAYMENT_METHOD_CONTINENTE_PAY = "ContinentePay";
const PAYMENT_METHOD_CONTINENTE_PAY_DA = "ContinentePayDa";
const PAYMENT_METHOD_PAYPAL = "PayPal";
const PAYMENT_METHOD_MBWAY = "MBWay";

/**
 * Payment Methods Icon Name
 */
const PAYMENT_ICON_VISA = "visa";
const PAYMENT_ICON_MASTERCARD = "mastercard";

/**
 * Summary constants
 */
const SUMMARY_SPACING_BOTTOM = 90;
const OFFSET_DIFFERENCE_WHEN_ALIGNED_BOTTOM = 138;

/**
 * Checkout steps
 */
const SHIPPING_STEP = 2;
const PAYMENT_STEP = 3;
const REVIEW_STEP = 4;

/**
 * Form constants
 */
const TEXTAREA_SCROLL_STEP = 20;
const INPUT_BG_COLOR_DEFAULT = "rgb(255, 255, 255)";

/**
 * Credit cards limit
 */
const CREDIT_CARDS_LIMIT = 5;

/**
 * Common
 */
const SCROLL_TIMER_1S = 1000;
const TIMER_3S = 3000;
const SCROLL_TIMER_10MS = 10;
const CUSTOMER_TYPE_PARTICULAR = "Particular";
const CART = "cart";
const MINICART_QUANTITY_LIMIT = 10;
const ADDITIONAL_TOP_SPACING = 15;
const UNDO_DELAY_TIME = 5000;
const DEFAULT_PAGE_SIZE = 36;
const CHECKOUT_RECOMMENDATION_LIST = "Checkout Recommendations";
const MAX_CAROUSEL_TILES = 7;

/**
 * URL refinement params
 * Update Google Analytics - utm known parameters added to whitelist
 */
const NOT_REFINEMENT_PARAMS = ["q", "pid", "cgid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const DEFAULT_SORT_RULE = "best-matches";
const DEFAULT_SORT_RULE_CATEGORY = "categories-general";
const SEARCH_DEFAULT_SORT_RULE = "search-default-sorting";

/**
 * GTM constants
 */
const GTM_HOME = "home";
const GTM_CG = "c&g";
const GTM_WIN_32 = "Win32";
const GTM_IOS = "ios";
const GTM_ANDROID = "android";
const GTM_WEB = "web";
const GTM_MAC_INTEL = "MacIntel";
const GTM_CARD_ASSOCIATION = "card association";
const GTM_CARD_REMOVAL = "card removal";
const GTM_NEW_ADDRESS = "new address";
const GTM_CHANGE_ADDRESS = "change address";
const GTM_SUCCESS = "success";
const GTM_ERROR = "error";
const GTM_CREATE = "create";
const GTM_SHIPPING = {
    "address": "Receber na Morada",
    "store": "Click & Go"
};

/**
 * Cookies
 */
const COOKIE_BANNER_VALUE = "1";
const COOKIE_HOURS_IN_A_DAY = 24;
const COOKIE_MINUTES_IN_A_HOUR = 60;
const COOKIE_SECONDS_IN_A_MINUTE = 60;
const COOKIE_MILISECONDS_IN_A_SECOND = 1000;

const COOKIE_MAILING_ANON_NAME = "MailingAnonID";
const COOKIE_MAILING_ANON_EXP_DAYS = 120;
const COOKIE_MAILING_ANON_SALT = "Continente";

// Coupons
const COUPONS_LIMIT = 20;

const PRICETYPES = {
    SUPERPRICE: "superprice",
    LOYALTY: "loyalty",
    PVPR: "pvpr",
    PERCENT: "percent",
    AMOUNT: "amount",
    PVPR_MIN: "poupe"
};

const constants = {
    COOKIE_BANNER_VALUE,
    COOKIE_HOURS_IN_A_DAY,
    COOKIE_MINUTES_IN_A_HOUR,
    COOKIE_SECONDS_IN_A_MINUTE,
    COOKIE_MILISECONDS_IN_A_SECOND,
    COOKIE_MAILING_ANON_NAME,
    COOKIE_MAILING_ANON_EXP_DAYS,
    COOKIE_MAILING_ANON_SALT,
    CONTAINER_WRAPPER,
    SPACING_WIDTH_DESKTOP,
    CATEGORY_REFINEMENT_LIMIT,
    MAP_MARKER_PATH,
    MAP_MARKER_COLOR,
    MAP_DARK_MARKER_COLOR,
    MAP_LABEL_COLOR,
    MAP_LABEL_FONT_SIZE,
    MAP_AUTH_FAILED_CLASS,
    SCHEDULE_ITEM_HEIGHT,
    SCHEDULE_COLUMNS_NUMBER,
    SCHEDULE_COLUMNS_NUMBER_TABLET,
    PAYMENT_METHOD_INPUT_DEFAULT_NAME,
    PAYMENT_METHOD_MODE_OFFLINE,
    PAYMENT_METHOD_GIFT_CARD,
    PAYMENT_METHOD_LOYALTY_CARD,
    PAYMENT_METHOD_CREDIT_CARD,
    PAYMENT_METHOD_CONTINENTE_PAY,
    PAYMENT_METHOD_CONTINENTE_PAY_DA,
    PAYMENT_METHOD_PAYPAL,
    PAYMENT_METHOD_MBWAY,
    SUMMARY_SPACING_BOTTOM,
    TEXTAREA_SCROLL_STEP,
    INPUT_BG_COLOR_DEFAULT,
    CREDIT_CARDS_LIMIT,
    SCROLL_TIMER_1S,
    TIMER_3S,
    SCROLL_TIMER_10MS,
    CUSTOMER_TYPE_PARTICULAR,
    NOT_REFINEMENT_PARAMS,
    DEFAULT_SORT_RULE,
    DEFAULT_SORT_RULE_CATEGORY,
    SEARCH_DEFAULT_SORT_RULE,
    CART,
    MINICART_QUANTITY_LIMIT,
    ADDITIONAL_TOP_SPACING,
    UNDO_DELAY_TIME,
    DEFAULT_PAGE_SIZE,
    CHECKOUT_RECOMMENDATION_LIST,
    MAX_CAROUSEL_TILES,
    GTM_HOME,
    GTM_CG,
    GTM_WIN_32,
    GTM_MAC_INTEL,
    GTM_IOS,
    GTM_ANDROID,
    GTM_WEB,
    GTM_CARD_ASSOCIATION,
    GTM_CARD_REMOVAL,
    GTM_NEW_ADDRESS,
    GTM_CHANGE_ADDRESS,
    GTM_SUCCESS,
    GTM_ERROR,
    GTM_CREATE,
    GTM_SHIPPING,
    DROPDOWN_ACTIVE_CLASS,
    OFFSET_DIFFERENCE_WHEN_ALIGNED_BOTTOM,
    AUTO,
    MASK_ACTIVE_CLASS,
    PAGE_HEIGHT_SET_TIMING,
    PERCENTAGE_SYMBOL,
    MIN_PRODUCT_QUANTITY,
    BRAND_COL,
    BRAND_ZU,
    PRICETYPES,
    BRAND_NAME_COL,
    BRAND_NAME_ZU,
    COUPONS_LIMIT,
    SHIPPING_STEP,
    PAYMENT_STEP,
    REVIEW_STEP,
    PAYMENT_ICON_VISA,
    PAYMENT_ICON_MASTERCARD
};

Object.keys(constants).forEach((key) => {
    if (typeof window[key] !== "undefined") {
        constants[key] = window[key];
    }
});

module.exports = constants;
